// extracted by mini-css-extract-plugin
export default {"model":"Model_model__g8f8i","model__view":"Model_model__view__q6nQv"};